const ThreeDSReturn = () => {
  const urlParams = new URLSearchParams(window.location.search)
  const clientSecret = urlParams.get('setup_intent_client_secret')
  window?.top?.postMessage({ completed: '3DS-authentication-complete', secret: clientSecret })

  return <></>
}

export default ThreeDSReturn
